/**
 * @deprecated Use `usePermissions()` from './usePermissions' instead.
 * The page-permission system is being retired in favor of verb-level
 * permissions backed by dbo.ItemProperties (Matt Holton 2026-05-04).
 * Kept live during cutover; removed in a follow-up cleanup PR.
 */
import { useContext } from 'react';
import { PagePermissionContext, type PagePermissionContextValue } from './PagePermissionContext';

export function usePagePermissions(): PagePermissionContextValue {
  return useContext(PagePermissionContext);
}
